import o from"styled-components";import{theme as i}from"../../../../theme.js";const t=o.div`
  display: flex;
  gap: ${i.spacing*2}px;
  > div {
    position: relative;
    > span {
      display: none;
    }
    &:hover {
      > span {
        position: absolute;
        top: 0;
        left: 32px;
        padding: ${i.spacing*2}px;
        display: block;
        z-index: 1;
        min-width: 200px;
        max-width: 300px;
        width: max-content;
        background-color: ${i.colors.gray[50]};
        box-shadow: ${i.boxShadow};
        border-radius: ${i.radius}px;
      }
    }
  }
  @media screen and (max-width: ${i.breakpoints.lg}) {
    position: relative;
    > div {
      position: static;
      &:hover {
        > span {
          left: 0;
          top: 8px;
          width: 100%;
          max-width: 100%;
          min-width: 100%;
          box-sizing: border-box;
        }
      }
    }
  }
`;export{t as Container};
